module.exports = __webpack_public_path__ + "static/media/xml.593b81a7.svg";